import { createHashRouter, createRoutesFromElements, Route } from 'react-router';
import { Navigate } from 'react-router';

import RouteErrorFallback from '../components/RouteErrorFallback';
import { suspendPageLoad } from './suspendPageLoad';
import { routes } from './routes';
import { App } from '../features/app/App';

// Lazy load pages for better performance and automatically split the bundle accordingly
const Accounts = suspendPageLoad(() => import('../pages/Accounts'));
const PartnerIntegrations = suspendPageLoad(() => import('../pages/PartnerIntegrations'));
const ClientMetrics = suspendPageLoad(() => import('../pages/ClientMetrics'));
const InboundConnectionsIframe = suspendPageLoad(() => import('../pages/EmbeddedInboundConnections'));

const routesFromElements = createRoutesFromElements(
    <Route element={<App />} errorElement={<RouteErrorFallback />}>
        <Route path={routes.DEFAULT} element={<Accounts />} />
        <Route path={routes.PARTNER_INTEGRATIONS} element={<PartnerIntegrations />} />
        <Route path={routes.CLIENT_METRICS} element={<ClientMetrics />} />
        <Route path={routes.INBOUND_CONNECTIONS} element={<InboundConnectionsIframe />} />

        <Route path='*' element={<Navigate to={routes.DEFAULT} />} />
    </Route>
);

export const router = createHashRouter(routesFromElements);
